export var isColorDark = function (color) { return getBrightness(color) < 150; };
var rgbToHex = function (r, g, b) {
    return '#' + ((1 << 24) + (r << 16) + (g << 8) + b).toString(16).slice(1);
};
var toHex = function (anyValue) {
    var _a, _b;
    if (anyValue.match(/^r/)) {
        var values = ((_b = (_a = anyValue.match(/^rgba?\(([^)]*)\)/i)) === null || _a === void 0 ? void 0 : _a[1]) !== null && _b !== void 0 ? _b : '0,0,0').split(',').map(function (item) { return parseInt(item, 10); });
        return rgbToHex(values[0], values[1], values[2]);
    }
    else {
        return anyValue;
    }
};
var getBrightness = function (color) {
    var hexCode = toHex(color);
    var _hexCode = hexCode.replace('#', '');
    var r = parseInt(_hexCode.substr(0, 2), 16);
    var g = parseInt(_hexCode.substr(2, 2), 16);
    var b = parseInt(_hexCode.substr(4, 2), 16);
    return (r * 299 + g * 587 + b * 114) / 1000;
};
//# sourceMappingURL=index.js.map